module.exports = __webpack_public_path__ + "img/lvyou.87f9eab5.png";